<ng-container *transloco="let t">
  <authority-labs-check-case
    [inspection]="inspection"
    [fieldSection]="fieldSection"
    [printPreview]="printPreview"
    [readonly]="readonly"
    (dataChange)="onChange()"
  >
    <mat-form-field
      appearance="fill"
      *ngIf="!(readonly || printPreview)"
      (selectionChange)="onChange()"
    >
      <mat-label>{{
        t('inspection.fields.preactionSystem:systemType')
      }}</mat-label>
      <mat-select [(ngModel)]="inspection.type">
        <mat-option *ngFor="let type of types" [value]="type">
          {{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill" *ngIf="readonly || printPreview">
      <mat-label>{{
        t('inspection.fields.preactionSystem:systemType')
      }}</mat-label>
      <input matInput [(ngModel)]="inspection.type" readonly />
    </mat-form-field>
  </authority-labs-check-case>
</ng-container>
